import {validateField, clearFields, setFieldOptions} from './helpers/form'
import {
  SET_TALENT_EXPORT_DROPDOWN_OPTIONS,
  VALIDATE_TALENT_EXPORT_FIELD,
  CLEAR_TALENT_EXPORT_FIELDS
} from '../../../actions/pages/talent-export-page'
import {getCountryNames, getSelectedCountryCode} from '../../../panel-admin/common/functions/countrySetting'

export function talentExportPage (
  state = {
    valid: false,
    fields: [
      {
        name: 'StatusName',
        value: 'Active',
        errors: [],
        rules: {
          title: 'Status',
          required: true
        },
        placeholder: 'Any status',
        options: [
              {
                value: "Inactive",
                label: "Inactive",
                parameters: null
              },
              {
                value: "Active",
                label: "Active",
                sparameters: null
              },
              {
                value: "Deleted",
                label: "Deleted",
                sparameters: null
              }
        ]
      },
      {
        name: 'CountryName',
        value: getSelectedCountryCode() ? getSelectedCountryCode().toUpperCase(): '',
        errors: [],
        rules: {
          title: "Country",
          required: true
         },
        placeholder: 'Any country',
        options: getCountryNames()
      },
    ]
  },
  action
) {
  switch (action.type) {
    case SET_TALENT_EXPORT_DROPDOWN_OPTIONS: {
      var newState = setFieldOptions(state, 'CountryName', action.countryNames);
      return setFieldOptions(newState, 'StatusName', action.statuses);
    }

    case VALIDATE_TALENT_EXPORT_FIELD: {
      return validateField(state, action);
    }

    case CLEAR_TALENT_EXPORT_FIELDS: {
      return clearFields(state);
    }

    default:
      return state
  }
}
